import {
  innobuzz,
  businessModel,
  kautilya,
  c2,c1,b3,b2,b1,a1,a2,a3,
  jayashri,rachna,
  director,neel,aditi,saurabh,prachi,siddhi,netra,
  shriya,nausheen,sharma,
  satyam,rutuja,amey,divya,piyush,vaishnavi
} from "../assets";

export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "about",
    title: "About",
  },
  {
    id: "event",
    title: "Events",
  },
  {
    id: "gallery",
    title: "Gallery",
  },
  
  {
    id: "wings",
    title: "Kautilya",
  },
  {
    id: "testimonials",
    title: "Testimonials",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "/team",
    title: "Team",
  },
];
const events = [
  {
    title: "Ideation Workshop",
    icon: innobuzz,
    iconBg: "#383E56",
    date: "23-24 April 2023",
    points: [
      "Jointly organized by SGGSIET-AICTE IDEA Lab and IIC. Mr. Satish Ranade, startup advisor and mentor was expert for the workshop. About 45 students and 5 faculty members attended the workshop. Prof. R.R. Manthalkar and Piyush Kadethankar coordinated the event."
    ],
    site: "https://www.google.com/",
  },
  {
    title: "Aurdino Workshop",
    
    icon: businessModel,
    iconBg: "#E6DEDD",
    date: "19 April 2023",
    points: [
      "Jointly organized by The Official Finance & Entrepreneurship Development Cell - TEAM KAUTILYA and SGGSIET-AICTE IDEA Lab.Mr. Adarsh Bhosle & Mr. Piyush Hemant Kadethankar Coordinated the entire event & made sure that all the students have got the good understanding of the Basic Concepts of Aurdino IDE, Aurdino Programming & Basic Circuit Building.  The purpose of this workshop was to give students the basic introduction to Various Microcontrollers like Aurdino, Raspberry pi etc.",
    ],
    site: "https://www.google.com/",
  },
  {
    title: "Finance and Accounting Workshop",
    icon: innobuzz,
    iconBg: "#383E56",
    date: "Jan 2024",
    points: [
      "This workshop was hosted by CA Anand Kabra and his daughter for giving student sights about how Finance and Accounting plays an important aspect for an Entrepreneur. It covers every thing regarding taxation and basic financial management. About 110 student attended this workshop which was divided into two parts. It was helpfull for student to understand how accounting and financing is done and moreover help them in future with their Entrepreneurship journey.",
    ],
    site: "https://www.google.com/",
  },
  {
    title: "In-House Training",
    
    icon: businessModel,
    iconBg: "#E6DEDD",
    date: "Feb 2024",
    points: [
      "In-House Training was a activity conducted in collaboration with Idea Lab. Students were made aware and trained about the instruments that were available in idea lab. That has help them to get hand on experience on instruments. All safety measures and and precaution were taken and about 45 students were part of this program under the guidance of core members and president of the cell.",
    ],
    site: "https://www.google.com/",
  },
 
];



const wings = [
  
  {
    title: "Team Kautilya",
    about:
      "dedicated to the overall development of students in the areas of Finance, Innovation and entrepreneurship. We strive to empower students through workshops, seminars, and interactive sessions, providing Financial Literacy and Fostering an Entrepreneurial Spirit.",
    url: kautilya,
  }
 
];
const teams = {

  FactAdv:[
    {
      name: "Ms.Jayashri Waghmare",
      designation: "Faculty Cordinator",
      url: jayashri,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Ms.Rachna",
      designation: "Faculty Cordinator",
      url: rachna,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    }
  ],
  lead: [
    {
      name: "Piyush Kadethankar",
      designation: "President",
      url:amey,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Rutuja Rathod",
      designation: "Secretary",
      url: rutuja,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    }
    
  ],
  member: [

    
    {
      name: "Divya Devdhe",
      designation: "General Operation",
      url: divya,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Amey Pande",
      designation: "Corporate Relation",
      url: amey,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Satyam Patil",
      designation: "Financial Activities",
      url: satyam,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Vaishnavi Bodake",
      designation: "R&D",
      url: vaishnavi,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
   
    
  ],

  Jmember: [
    {
      name: "Neel Chavan",
      designation: "Member",
      url: neel,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Aditi Khetan",
      designation: "Member",
      url: aditi,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Nausheen Akbar Sheikh",
      designation: "Member",
      url: nausheen,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Saurabh Ramesh Tikar",
      designation: "Member",
      url: saurabh,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Shriya Kuppa",
      designation: "Member",
      url: shriya,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Netra Deshpande",
      designation: "Graphic Designing",
      url: netra,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Prachi Pataliya",
      designation: "Member",
      url: prachi,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    {
      name: "Siddhi Borgaokar",
      designation: "Member",
      url: siddhi,
      ilink: "#",
      flink: "#",
      llink: "#",
      tlink: "#",
    },
    
    
    
  ]
};

const GalleryData = [
  {
      id:1,
      titile:"TedX",
      image:a1
  },
  {
      id:2,
      titile:"TedX",
      image:a2
  },
  {
      id:3,
      titile:"TedX",
      image:a3
  },
  {
      id:4,
      titile:"Innobuzz",
      image:b1
  },
  {
      id:5,
      titile:"Innobuzz",
      image:b2
  },
  {
      id:6,
      titile:"Innobuzz",
      image:b3
  },
  {
      id:7,
      titile:"Family",
      image:c1
  },
  {
      id:8,
      titile:"Family",
      image:c2
  },
]
 
const Testimonials=[
  {
    name:'Dr. Manish Kokare',
    url:director,
    caption:'Director',
    details:'Big dream and Big Goals only come true if we do Hardwork.',
  },
  {
    name:'Dr. Jayashri Waghmare',
    url: jayashri,
    caption:'Cordinator',
    details:'going greate',
  },
  {
    name:'Dr. Rachna ',
    url: rachna,
    caption:'Cordinator',
    details:'Experience is more important that knowledge from book ',
  },
  {
    name:'Devansh Sharma',
    
    caption:'Dictator',
    details:'push yourself  ',
  },
 
 
]

const update = [
  {
    title: "CSS and TailWind Workshop",
    icon: innobuzz,
    iconBg: "#383E56",
    date: "23-24 April 2023",
    points: [
      "Jointly organized by IT department and CS by Mr. rutwik jadhav"
    ],
    site: "https://www.google.com/",
  },

]

export { events,  wings, teams,GalleryData, Testimonials,update };
